

export const getCount = state => {
    return state.count
}

export const getToken = state=>{	
   let user = JSON.parse(sessionStorage.getItem('user'));
   return state.token = user.token
}

export const getUserId = state=>{
	let user = JSON.parse(sessionStorage.getItem('user'));
	return (state.userid = user.userid)
}

export const getAdvertiserId = state=>{
	return state.advertiser_id
}

export const getActive = state=>{
	return state.active
}

export const getFiltering = state=>{
	return state.filtering
}

export const getRulesAdvertiserId = state=>{
	return state.rule_advertiser_id
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js